// extracted by mini-css-extract-plugin
module.exports = {"photo":"_93444fe79c--photo--OQqGD","info":"_93444fe79c--info--XltzK","price":"_93444fe79c--price--FQCaB","link":"_93444fe79c--link--jpabx"};